module.exports = __webpack_public_path__ + "img/logout-icon.687886ee.svg";